import React, { useState } from "react";
import cn from "classnames";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import OutsideClickHandler from "react-outside-click-handler";
import Icon from "../../../components/Icon";
import GlobalSearch from "./GlobalSearch";
import styles from "./TopBar.module.sass";

const TopBar = ({ className }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [createOpen, setCreateOpen] = useState(false);

  const createItems = [
    { key: "deck", icon: "list", label: t("home.topbar.createDeck", "Deck"), to: "/deck/add" },
    { key: "card", icon: "photos", label: t("home.topbar.createCard", "Card"), to: "/card/add" },
    { key: "text", icon: "edit", label: t("home.topbar.createText", "Texto"), to: "/texts/add" },
    {
      key: "notification",
      icon: "notification",
      label: t("home.topbar.createNotification", "Notificación"),
      to: "/notification",
    },
  ];

  return (
    <div className={cn(styles.bar, className)}>
      <GlobalSearch />
      <div className={styles.actions}>
        <OutsideClickHandler onOutsideClick={() => setCreateOpen(false)}>
          <div className={styles.createWrap}>
            <button
              type="button"
              className={styles.create}
              onClick={() => setCreateOpen((v) => !v)}
            >
              <Icon name="plus" size="16" />
              <span>{t("home.topbar.create", "Crear")}</span>
            </button>
            {createOpen && (
              <div className={styles.menu}>
                {createItems.map((item) => (
                  <button
                    key={item.key}
                    type="button"
                    className={styles.menuItem}
                    onClick={() => {
                      setCreateOpen(false);
                      history.push(item.to);
                    }}
                  >
                    <Icon name={item.icon} size="16" />
                    {item.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </OutsideClickHandler>
      </div>
    </div>
  );
};

export default TopBar;
